


















import { Component, Prop, Vue } from 'vue-property-decorator';
import Legend from '@arcgis/core/widgets/Legend';

@Component
export default class EsriLegend extends Vue {

    public legend: __esri.Legend | null = null;

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'toggleLegend') {
            this.initLegend();
        }
    });

    get showLegend() {
        return this.$store.state.heatmap.showLegend;
    }

    get mapView() {
        return this.$store.state.mapView;
    }

    public async initLegend() {
        if (!this.legend) {
            console.log('EsriLegend: initLegend()');
            this.legend = new Legend({
                view: this.mapView,
                container: 'legend',
            });
            console.log(this.legend);
        }
    }

    public toggleShow() {
        this.$store.dispatch('toggleLegend');
    }

    public async mounted() {
        console.log('EsriLegend: mounted()');
    }

    public beforeDestroy() {
        console.log('EsriLegend: beforeDestroy()');
        this.unsubscribe();
    }

}

